<template>
  <div class="alertNameTop-container">
    <div class="rangeContainer">
      <simple-select
        :options="rangeOptions"
        :autoSelect="false"
        :label-in-value="false"
        v-model="currentRange"
      ></simple-select>
    </div>

    <a-spin :spinning="loading">
      <div v-if="detail.length" style="min-height: 240px">
        <alert-info-top
          :detail="detail"
          :img-height="18"
        ></alert-info-top>
      </div>
      <div v-else style="min-height: 240px; position: relative; overflow: hidden;">
        <empty-component
          :body-style="{
            height: '186px',
            marginTop: '14px'
          }"
          :description-style="{
            marginTop: '-32px'
          }"
        ></empty-component>
      </div>
    </a-spin>
  </div>
</template>

<script>
import moment from 'moment'
import { getAlertTop } from '@/api/alert'
import SimpleSelect from '@/components/select/SimpleSelect'
import AlertInfoTop from '@/components/top/AlertInfoTop'
import EmptyComponent from '@/components/EmptyComponent.vue'

export default {
  name: 'AlertNameTop',
  components: {
    AlertInfoTop,
    SimpleSelect,
    EmptyComponent
  },
  data () {
    const rangeOptions = [
      { label: '近 7 日', value: 'week' },
      { label: '近 15 日', value: 'half_month' },
      { label: '近 30 日', value: 'month' }
    ]
    return {
      rangeOptions,
      detail: [],
      currentRange: 'half_month',
      loading: false
    }
  },
  computed: {
    params () {
      if (this.currentRange === 'week') {
        return {
          datetime_from: moment().subtract(6, 'day').format('YYYY-MM-DD HH:mm'),
          datetime_to: moment().format('YYYY-MM-DD HH:mm'),
          top_of: 'name',
          limit: 5
        }
      }
      if (this.currentRange === 'month') {
        return {
          datetime_from: moment().subtract(30, 'day').format('YYYY-MM-DD HH:mm'),
          datetime_to: moment().format('YYYY-MM-DD HH:mm'),
          top_of: 'name',
          limit: 5
        }
      }
      return {
        datetime_from: moment().subtract(14, 'day').format('YYYY-MM-DD HH:mm'),
        datetime_to: moment().format('YYYY-MM-DD HH:mm'),
        top_of: 'name',
        limit: 5
      }
    }
  },
  created () {
    this.fetch()
  },
  watch: {
    params () {
      this.fetch()
    }
  },
  methods: {
    fetch () {
      this.loading = true
      getAlertTop(this.params).then(res => {
        if (res.data) this.detail = res.data.data
        else this.detail = []
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 100)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.alertNameTop-container {
  position: relative;
  padding-top: 26px;
  height: 100%;

  .rangeContainer {
    position: absolute;
    right: 0px;
    top: -18px;
  }

  :deep(#alert-info) {
    .alert-info-item {
      height: 36px;
      margin-bottom: 10px;
      font-size: 13px;
      font-weight: 400;
      line-height: 36px;
      padding: 6px 12px;
      .item-img {
        margin: 0 14px 2px 0;
      }
      .item-no {
        margin-right: 6px;
      }
      .item-value {
        font-size: 16px;
        color: #1162ba;
        line-height: 20px;
      }
    }
  }
}
</style>
